<template>
    <v-layout row wrap>
        <div @mouseenter="mouseOverTooltip = true" @mouseleave="mouseOverTooltip = false" class="booking-tooltip"
             :style="!tooltipStyle ? 'opacity: 0; display: none;' : tooltipStyle">
            <template v-if="!!tooltip.attach">
                <b>
                    {{tooltip.bookingFrom.format("HH:mm")}} - {{tooltip.bookingTo.format("HH:mm")}}
                </b>
                <br>
                from: {{tooltip.booking.pick_up_location_name}}
                <br>
                to: {{tooltip.booking.pull_down_location_name}}
                <br>
                <b>
                    <router-link :to="{name: 'PassengerProfile',params: {id: tooltip.booking.passenger_id}}"
                                 target="_blank">
                        {{tooltip.booking.passenger.first_name}} {{tooltip.booking.passenger.last_name}}
                    </router-link>
                </b>
                <br>
                user: {{tooltip.booking.user.first_name}} {{tooltip.booking.user.last_name}}
                <br>
                <template v-if="tooltip.booking.summary">
                    Estimated Time: {{Number(tooltip.booking.summary.estimated_time).toFixed(2)}}
                    <br>
                    Estimated Price: {{Number(tooltip.booking.summary.estimated_price).toFixed(2)}}
                    <br>
                </template>
                created at: {{tooltip.booking.created_at}}
                <br>
                booking id : {{tooltip.booking.id}}
                <br>
                ride id : {{tooltip.booking.ride_id}}
            </template>
        </div>

        <v-flex xs12>
                <span
                        v-for="(color,state) in statusColors"
                        class="color-identifier"
                        :style="'background-color: '+color+';min-width: 10px;padding: 3px 7px;font-size: 12px;font-weight: 700;line-height: 1;color: #fff;text-align: center;white-space: nowrap;vertical-align: middle;border-radius: 10px;'">{{state}}</span>

        </v-flex>
        <v-dialog :value="!!activeRideId" lazy @input="activeRideId = null">
            <ride-page v-if="activeRideId" :ride_id="activeRideId"/>
        </v-dialog>
        <v-flex xs12>
            <v-layout row wrap justify-space-around>
                <choose-date v-model="from" clearable label="From"/>
                <choose-date v-model="to" clearable label="To"/>
            </v-layout>
        </v-flex>
        <v-flex xs12 class="mt-2">
            <full-calendar
                    ref="calendar"
                    default-view="resourceTimelineDay"
                    resource-label-text="Day"
                    resource-area-width="150px"
                    slot-duration="00:60:00"
                    slot-width="10%"
                    @eventClick="eventClick"
                    now-indicator="true"
                    :editable="false"
                    height="auto"
                    :droppable="false"
                    :resources="resources"
                    @eventMouseEnter="eventMouseEnter"
                    @eventMouseLeave="eventMouseLeave"
                    :events="events"
                    :plugins="calendarPlugins"
            />
        </v-flex>
        <v-flex xs12>
            <v-layout row wrap align-center justify-center>
                <v-btn large flat color="primary" :loading="true" v-if="loading"/>
                <v-btn large icon flat v-else-if="resources.length < total" @click="getNextData()">
                    <v-icon size="48" color="primary" style="width:100%">
                        fa fa-caret-down
                    </v-icon>
                </v-btn>
                <v-btn large primary flat v-else>
                    You've reached the end of the list
                </v-btn>
            </v-layout>
        </v-flex>
    </v-layout>
</template>

<script>


    import ChooseDate from "@/components/wasilni/input/ChooseDate";
    import FullCalendar from "@fullcalendar/vue";
    import ResourceTimeline from "@fullcalendar/resource-timeline"
    import FullCalendarMoment from "@fullcalendar/moment";
    import FullCalendarInteraction from "@fullcalendar/interaction";
    import moment from "moment";
    import RidePage from "@/views/RidePage";
    import _ from "lodash";

    export default {
        components: {ChooseDate, FullCalendar, RidePage},
        props: {
            captainId: {
                required: true
            }
        },
        data() {
            return {
                from: null,
                to: null,
                loading: false,
                current_page: 1,
                total: null,
                bookings: [],
                resources: [],
                check_logs: [],
                activeRideId: null,
                mouseOverTooltip: false,
                tooltip: {},
                tooltipStyle: null,

            }
        },
        watch: {
            mouseOverTooltip(val) {
                if (!val)
                    this.tooltipStyle = null;

            },
            params() {
                this.resources = [];
                this.bookings = [];
                this.check_logs = [];
                this.current_page = 1;
                this.total = null;
                this.getData();
            }
        },
        methods: {
            eventMouseEnter({event, el, jsEvent}) {
                setTimeout(() => {
                    if (this.mouseOverTooltip)
                        return;
                    if (event.extendedProps.type === "Booking") {
                        const fullCalendarScrollers = this.$refs.calendar.getApi().el.getElementsByClassName("fc-scroller");
                        const {clientX: x, clientY: y} = jsEvent;
                        this.tooltipStyle = `position: fixed; top: ${y}px; left: ${x + 10}px; opacity: 1;`;
                        const booking = event.extendedProps.booking;
                        const bookingFrom = moment(event.start);
                        const bookingTo = moment(event.end);
                        this.tooltip = {
                            attach: el,
                            booking,
                            bookingFrom,
                            bookingTo
                        };
                    } else {
                        this.tooltipStyle = null;
                    }
                }, 100);
            },
            eventMouseLeave({event}) {
                setTimeout(() => {
                    if (this.mouseOverTooltip)
                        return;
                    if (event.extendedProps.type === "Booking")
                        this.tooltipStyle = null;
                }, 100);
            },
            eventClick({event}) {
                if (event.extendedProps.type === "Booking")
                    this.activeRideId = event.extendedProps.booking.ride_id;
            },
            getNextData() {
                this.current_page += 1;
                this.getData();
            },
            async getData() {
                this.loading = true;
                const params = this.params;
                if (this.current_page)
                    params.append("page", this.current_page);
                const {data: {data: paginator}} = await this.axios
                    .get(this.api.ACTIONS.CAPTAIN_TIMELINE(this.captainId), {params});
                this.current_page = paginator.current_page;
                this.total = paginator.total;
                this.bookings = _.flatten([...this.bookings, ...paginator.data.map(i => i.bookings)]);
                this.resources = [...this.resources, ...paginator.data.map(i => ({name: i.date, id: i.date}))];
                this.check_logs = _.flatten([...this.check_logs, ...paginator.data.map(i => i.check_logs)]);
                this.loading = false;
            }
        },
        computed: {
            statusColors() {
                return {
                    APPROVED: '#f17cf7',
                    ACCEPTED: '#8e8e88',
                    STARTED: "#5abbca",
                    ARRIVED: "#ffa60c",
                    PICKED_UP: "#e04b4a",
                    DONE: "#8b8e2a",
                    PAID: "#127460",
                    CANCELLED: "#ffb00c",
                    PAX_CANCELLED: "#fff503",
                    CAX_CANCELLED: "#ffb826",
                    SYSTEM_CANCELLED: "#ff9b05",
                    ONLINE: "#004400"
                }
            },
            events() {
                let data = [];
                const handled_check_logs = [];
                const today = moment().format("YYYY-MM-DD");

                this.bookings.forEach(
                    booking => {
                        data.push({
                            resourceId: moment(booking.datetime).format("YYYY-MM-DD"),
                            title: booking.passenger.first_name + ' ' + booking.passenger.last_name,
                            type: "Booking",
                            start: moment(today + ' ' + booking.datetime.split(" ")[1]).toDate(),
                            end: moment(today + ' ' + booking.datetime.split(" ")[1]).add(booking.summary ? booking.summary.estimated_time : 60, 'minutes').toDate(),
                            id: booking.id,
                            order: 2,
                            color: this.statusColors[booking.status],
                            booking
                        });
                    });

                this.check_logs.forEach(
                    check_log => {
                        if (handled_check_logs.indexOf(check_log.id) !== -1)
                            return;

                        for (let {name: date} of this.resources) {
                            const from = moment(check_log.from_datetime).format("YYYY-MM-DD");
                            const to = moment(check_log.to_datetime).format("YYYY-MM-DD");

                            if (date >= from && date <= to) {
                                const start = date > from ? "00:00:00" : check_log.from_datetime.split(" ")[1];
                                const end = date < to ? "23:59:59" : (check_log.to_datetime ? check_log.to_datetime.split(" ")[1] : moment().format("HH:mm:ss"));
                                data.push({
                                    resourceId: date,
                                    title: "Online",
                                    type: "CheckLog",
                                    start: moment(today + ' ' + start).toDate(),
                                    end: moment(today + ' ' + end).toDate(),
                                    id: check_log.id,
                                    order: 1,
                                    color: this.statusColors.ONLINE,
                                    check_log
                                });
                            }
                        }

                        handled_check_logs.push(check_log.id);
                    }
                );

                return data;
            },
            params() {
                const params = new URLSearchParams();

                params.append("from", this.from || "");
                params.append("to", this.to || "");

                return params;
            },
            calendarPlugins() {
                return [ResourceTimeline, FullCalendarMoment, FullCalendarInteraction];
            },
        },
        mounted() {
            this.getData();
        },
        name: "captain-timeline"
    }
</script>

<style lang="scss" scoped>
    @import '~@fullcalendar/resource-timeline/main.css';
    @import '~@fullcalendar/core/main.css';
    @import '~@fullcalendar/timeline/main.css';
</style>

<style scoped lang="scss">

    > > > .fc-toolbar {
        display: none;
    }

    > > > .fc-license-message {
        display: none;
    }

    .booking-tooltip {
        position: absolute;
        float: left;
        padding: 8px;
        z-index: 10;
        background-color: #c5c5c5ee;
        transition: opacity 100ms;

        * {
            background-color: unset;
        }
    }
</style>